import {
    Component,
    EventEmitter,
    inject,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';

import { FileStateService } from '../../../services/file-state.service';

@Component({
    selector: 'historical-modal',
    templateUrl: './historical-modal.component.html',
    styleUrls: ['./historical-modal.component.scss'],
    standalone: false,
})
export class HistoricalModalComponent implements OnChanges {
    @Input() visible = false;
    @Input() oldTitle = '';
    @Input() newTitle = '';
    @Input() action: 'Rename' | 'Delete' | 'DeleteFiles' | 'DeleteFile' | 'ExtendFiles' = 'Rename';

    @Output() newTitleChange = new EventEmitter<string>();
    @Output() cancel = new EventEmitter<void>();
    @Output() confirm = new EventEmitter<string>();

    private readonly _fileStateService = inject(FileStateService);

    modelTitle = '';
    confirmButtonTitle = '';

    isFileIntoConversation = this._fileStateService.isFileIntoConversation;

    /**
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['newTitle'] && !changes['newTitle'].firstChange) {
            this.modelTitle = changes['newTitle'].currentValue ?? '';
        }
        if (changes['visible'] && this.visible) {
            // Reset local model when opening
            this.modelTitle = this.newTitle ?? '';
        }

        switch (this.action) {
            case 'Rename':
                this.confirmButtonTitle = 'Rename Chat';
                break;
            case 'Delete':
                this.confirmButtonTitle = 'Delete Chat';
                break;
            case 'DeleteFile':
                this.confirmButtonTitle = 'Delete';
                break;
            case 'DeleteFiles':
                this.confirmButtonTitle = 'Delete';
                break;
            case 'ExtendFiles':
                this.confirmButtonTitle = 'Extend';
                break;
            default:
                this.confirmButtonTitle = 'Confirm';
                break;
        }
    }

    /**
     *
     * @param value
     */
    onTitleChange(value: string): void {
        this.modelTitle = value;
        this.newTitleChange.emit(value);
    }

    /**
     *
     */
    onCancel(): void {
        this.cancel.emit();
    }

    /**
     *
     */
    onConfirm(): void {
        const title = (this.modelTitle || '').trim();
        if (title) {
            this.confirm.emit(title);
        }
    }
}
